import { DecimalPipe, Time } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'time',
    standalone: false
})
export class TimePipe implements PipeTransform {

  decimalPipe = new DecimalPipe('de');

  transform(value: Time): string {
    return this.decimalPipe.transform(value.hours, '2.0-0') + ':' + this.decimalPipe.transform(value.minutes, '2.0-0') + ' Uhr';
  }

}
